import { 
    UPDATE_FILTER, 
    CLEAR_FILTER, 
    UPDATE_FILTER_NAME,
    UPDATE_FILTER_TYPE,
    UPDATE_FILTER_DATE,
    UPDATE_PAGE_NEXT_PAGE,
    UPDATE_FILTER_DISTANCE 
} from './types'

const filterState = {
        distance: 0,
        project_name: '',
        dates: {
            initial_date: null,
            final_date: null,
        },
        types: [{
                  selected: false,
                  name: 'natural',
                  value: 'natural',
                  key: 'natural'
                },
                {
                  selected: false,
                  name: 'industrializado',
                  value: 'industrialized',
                  key: 'industrialized'
                },
                {
                  selected: false,
                  name: 'granito',
                  value: 'granito',
                  key: 'granito'
                },
                {
                  selected: false,
                  name: 'mármore',
                  value: 'mármore',
                  key: 'marmore'
                },
                {
                  selected: false,
                  name: 'mármore composto',
                  value: 'mármore composto',
                  key: 'marmore_composto'
                },
                {
                  selected: false,
                  name: 'ônix',
                  value: 'ônix',
                  key: 'onix'
                },
                {
                  selected: false,
                  name: 'travertino',
                  value: 'travertino',
                  key: 'travertino'
                },
                {
                  selected: false,
                  name: 'quartzo',
                  value: 'quartzo',
                  key: 'quartzo'
                },
                {
                  selected: false,
                  name: 'quartzito',
                  value: 'quartzito',
                  key: 'quartzito'
                },
                {
                  selected: false,
                  name: 'ultra compacto',
                  value: 'ultra compacto',
                  key: 'ultra_compacto'
                }],
        limit: 20,
        page: 1,
        nextPage: null
}

const empyState = {
  distance: 0,
  project_name: '',
  dates: {
      initial_date: null,
      final_date: null,
  },
  types: [{
            selected: false,
            name: 'natural',
            value: 'natural',
            key: 'natural'
          },
          {
            selected: false,
            name: 'industrializado',
            value: 'industrialized',
            key: 'industrialized'
          },
          {
            selected: false,
            name: 'granito',
            value: 'granito',
            key: 'granito'
          },
          {
            selected: false,
            name: 'mármore',
            value: 'mármore',
            key: 'marmore'
          },
          {
            selected: false,
            name: 'mármore composto',
            value: 'mármore composto',
            key: 'marmore_composto'
          },
          {
            selected: false,
            name: 'ônix',
            value: 'ônix',
            key: 'onix'
          },
          {
            selected: false,
            name: 'travertino',
            value: 'travertino',
            key: 'travertino'
          },
          {
            selected: false,
            name: 'quartzo',
            value: 'quartzo',
            key: 'quartzo'
          },
          {
            selected: false,
            name: 'quartzito',
            value: 'quartzito',
            key: 'quartzito'
          },
          {
            selected: false,
            name: 'ultra compacto',
            value: 'ultra compacto',
            key: 'ultra_compacto'
          }],
  limit: 20,
  page: 1,
  nextPage: null
}

const updateMaterialType = (name, types) => {
    let copy = [ ...types ]
    return copy.map(item => {
        let copyItem = { ...item }
        
        if (name === copyItem.name) {
            copyItem.selected = !copyItem.selected
        }

        return copyItem
    })
}

const updateFinal = ({ initial, date}, oldDate) => {

    if (!date) {
        return {
            initial_date: oldDate.initial_date,
            final_date: oldDate.final_date
        }
    }

    if (date && initial) {
        return {
            initial_date: date,
            final_date: oldDate.final_date
        }
    }

    if (date && date < oldDate.initial_date) {
        return { 
            initial_date: date,
            final_date: oldDate.initial_date
        }
    } 
    
    return {
        initial_date: oldDate.initial_date,
        final_date: date
    }
    
}

const filterReducer = (state, actions) => {

    const { type, payload } = actions

    switch (type) {
        case CLEAR_FILTER: {
            return {
                distance: 0,
                project_name: '',
                dates: {
                    initial_date: null,
                    final_date: null,
                },
                types: [{
                          selected: false,
                          name: 'natural',
                          value: 'natural',
                          key: 'natural'
                        },
                        {
                          selected: false,
                          name: 'industrializado',
                          value: 'industrialized',
                          key: 'industrialized'
                        },
                        {
                          selected: false,
                          name: 'granito',
                          value: 'granito',
                          key: 'granito'
                        },
                        {
                          selected: false,
                          name: 'mármore',
                          value: 'mármore',
                          key: 'marmore'
                        },
                        {
                          selected: false,
                          name: 'mármore composto',
                          value: 'mármore composto',
                          key: 'marmore_composto'
                        },
                        {
                          selected: false,
                          name: 'ônix',
                          value: 'ônix',
                          key: 'onix'
                        },
                        {
                          selected: false,
                          name: 'travertino',
                          value: 'travertino',
                          key: 'travertino'
                        },
                        {
                          selected: false,
                          name: 'quartzo',
                          value: 'quartzo',
                          key: 'quartzo'
                        },
                        {
                          selected: false,
                          name: 'quartzito',
                          value: 'quartzito',
                          key: 'quartzito'
                        },
                        {
                          selected: false,
                          name: 'ultra compacto',
                          value: 'ultra compacto',
                          key: 'ultra_compacto'
                        }],
                limit: 20,
                page: 1,
                nextPage: null
            }
        }
        case UPDATE_FILTER: {
            return {
                ...state,
                ...payload
            }
        }
        case UPDATE_FILTER_NAME: {
            return {
                ...state,
                project_name: payload,
            }
        }
        case UPDATE_FILTER_TYPE: {
            return {
                ...state,
                types: updateMaterialType(payload, state.types),
            }
        }
        case UPDATE_FILTER_DATE: {
            return {
                ...state,
                dates: updateFinal(payload, state.dates),
            }
        }
        case UPDATE_PAGE_NEXT_PAGE: {
            return {
              ...state,
              page: payload.page,
              nextPage: payload.nextPage
            }
        }
        case UPDATE_FILTER_DISTANCE: {
          return {
            ...state,
            distance: payload
          }
        }
        default: {
          return state
        }
    }

}

export { filterReducer as default, filterState, empyState }